import styled from "styled-components";

import { primary } from "@formant/ui/component/common/Colors";
import { TextField } from "@formant/ui/component/common/TextField";

import { PasswordField } from "../common/PasswordField";
import { StandardButton } from "../common/StandardButton";

export const LoginContainer = styled.div<{ $topOffset?: string }>`
    margin-top: ${({ $topOffset }) => $topOffset || "3rem"};
    width: 22.5rem;
    @media (max-width: 30rem) {
        width: 100%;
    }
`;

export const TextFieldContainer = styled(TextField)`
    margin: 1.25rem 0rem;
`;

export const PasswordFieldContainer = styled(PasswordField)`
    margin: 1.25rem 0rem;
`;

export const OptionLabel = styled.label`
    display: flex;
    align-items: center;
    margin-right: 1.25rem;
    color: ${primary.silver};
    cursor: pointer;

    input[type="checkbox"] {
        margin-left: 0rem;
    }
`;

export const Option = styled.div`
    display: flex;
    align-items: center;

    @media (max-width: 30rem) {
        flex-direction: column;
    }

    a {
        margin-left: auto;
        @media (max-width: 30rem) {
            margin-left: unset;
            margin-top: $space-10;
        }
    }
`;

interface IButtonContainerProps {
    $marginTop?: string;
}

export const ButtonContainer = styled.div<IButtonContainerProps>`
    margin-top: ${props => (props.$marginTop ? props.$marginTop : "2.125rem")};
    display: flex;
    flex-direction: column;

    button {
        position: relative;
        padding: 0.75rem 1.875rem;
        margin-top: 1rem;
        margin-bottom: 0rem;
        width: 22.5rem;
        height: 2.5625rem;
    }

    @media (max-width: 30rem) {
        button {
            width: 100%;
        }
    }
`;

export const SignInButton = styled(StandardButton)`
    position: relative;
`;

export const Bottom = styled.div`
    text-align: center;
`;

export const HrWithText = styled.div`
    margin-top: 1.4375rem;
    display: flex;
    align-items: center;
`;

export const HrLine = styled.div`
    flex: 1;
    border-top: 1px solid var(--primary-module, #2d3855);
`;

export const HrText = styled.div`
    padding: 0 10px;
`;

export const StyledFooter = styled.div`
    padding-top: 1.75rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
`;
